import { Injectable, inject, signal } from '@angular/core';
import { ISocketMessage } from 'modelos/src';
import { Observable, Subject } from 'rxjs';
import { io, Socket } from 'socket.io-client';
import {
  ENV,
  NOMBRE_APP,
  VERSION,
  socketIoPath,
  socketIoServer,
} from 'src/environments/environment';
import { AuthService } from '../../entidades/login/auth.service';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  private authService = inject(AuthService);

  private socket?: Socket;
  private socketMsg$ = new Subject<ISocketMessage>();

  // Estado para el indicador de conexión (circulito verde).
  public readonly connected = signal(false);
  public readonly version = VERSION;
  public readonly env = ENV;

  constructor() {
    this.initWs();
  }

  public initWs() {
    // socket.io maneja reconexión/heartbeat solo; evitamos duplicar conexión.
    if (this.socket?.connected || this.socket?.active) {
      return;
    }
    const token = this.authService.getToken();
    if (!token || !socketIoServer) {
      console.log('No hay token o socketIoServer');
      return;
    }

    this.socket?.disconnect();
    this.socket = io(socketIoServer, {
      path: socketIoPath,
      transports: ['websocket', 'polling'],
      // Función: el token fresco viaja en cada (re)conexión.
      auth: (cb) =>
        cb({
          token: `Bearer ${this.authService.getToken()}`,
          appVersion: VERSION,
          app: NOMBRE_APP,
          appType: 'web',
        }),
    });

    this.socket.on('connect', () => {
      this.connected.set(true);
      console.log(`socket.io conectado ${socketIoServer}${socketIoPath}`);
    });
    this.socket.on('update', (message: ISocketMessage) =>
      this.socketMsg$.next(message),
    );
    this.socket.on('connect_error', (error) => {
      this.connected.set(false);
      console.log(`socket.io connect_error: ${error.message}`);
    });
    this.socket.on('disconnect', (reason) => {
      this.connected.set(false);
      console.log(`socket.io desconectado: ${reason}`);
    });
  }

  public getMessage(): Observable<ISocketMessage> {
    return this.socketMsg$.asObservable();
  }

  public closeWS() {
    console.log('funcion: closeWS = Cerrando socket.io');
    this.socket?.disconnect();
    this.socket = undefined;
    this.connected.set(false);
  }
}
